import APIAmplify from '@aws-amplify/api';
import { updateUserById } from '@/service/userService';
import { onProjectUpdated, onUserDeleted, onUserProjectDeletedByUserId, onCorporationUpdated, onTaskParentUpdated } from '@/graphql/subscriptions';
import Utils, { isAdminUser } from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { signOut } from '@/service/authenService';
import { cloneDeep, isEqual } from 'lodash';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { I18n, Storage } from 'aws-amplify';

let subscriptionEventDeleteProjectList = [];
let subscriptionDeleteUser;

export const updateLastTimeReadNotification = async (API, userId) => {
    if (!userId) {
        return;
    }

    let lastTimeReadNotification = new Date().toISOString();
    let userDetailForUpdate = {
        id: userId,
        readNotificationAt: lastTimeReadNotification
    };
    await updateUserById(API, userDetailForUpdate);
};

/**
 * onSubscriptionEventDeleteUser
 * event delete user
 * @param {*} allState
 * @param {*} mail
 */
export const onSubscriptionEventDeleteUser = (allState, id) => {
    if (!id) return;
    subscriptionDeleteUser = APIAmplify.graphql({
        query: onUserDeleted,
        variables: { id: id }
    }).subscribe({
        next: resData => {
            let userData = resData?.value?.data?.onUserDeleted;
            if (
                userData &&
                !Utils.isEmptyObject(userData) &&
                userData.active === Constant.ACTIVE_FLAG.DELETED
            ) {
                signOut(allState.history);
            }
        },
        error: err => {
            console.log('onSubscriptionEventDeleteUser err', err)
        }
    });
    return subscriptionDeleteUser
};

/**
 * unSubscriptionEventDeleteUser
 * unsubscribe event delete user in corp
 */
export const unSubscriptionEventDeleteUser = () => {
    if (subscriptionDeleteUser) {
        subscriptionDeleteUser.unsubscribe();
    }
}

export const checkReloadPanelUpdateCorpDetail = (
    corpSubscription,
    corporationDetail
) => {
    if (!Utils.isEmptyObject(corpSubscription)) {
        // Prepare debug info about why the reload is triggered
        const reasons = [];

        if (corpSubscription.deskService !== corporationDetail.deskService) {
            reasons.push('deskService');
        }
        if (corpSubscription.knowledgeService !== corporationDetail.knowledgeService) {
            reasons.push('knowledgeService');
        }
        if (corpSubscription.taskManagementService !== corporationDetail.taskManagementService) {
            reasons.push('taskManagementService');
        }
        if (corpSubscription.rootFlag !== corporationDetail.rootFlag) {
            reasons.push('rootFlag');
        }
        if (corpSubscription?.limitValue?.internalQACounterSettings !== corporationDetail.limitValue?.internalQACounterSettings) {
            reasons.push('internalQACounterSettings');
        }
        if (corpSubscription?.limitValue?.advancedOptionSettings !== corporationDetail.limitValue?.advancedOptionSettings) {
            reasons.push('advancedOptionSettings');
        }
        if (corpSubscription?.limitValue?.publicWebForm !== corporationDetail.limitValue?.publicWebForm) {
            reasons.push('publicWebForm');
        }
        if (corpSubscription?.limitValue?.emailResponseFunction !== corporationDetail.limitValue?.emailResponseFunction) {
            reasons.push('emailResponseFunction');
        }
        if (corpSubscription.publicService !== corporationDetail.publicService) {
            reasons.push('publicService');
        }
        if (corpSubscription?.limitValue?.knowledgeBot !== corporationDetail.limitValue?.knowledgeBot) {
            reasons.push('knowledgeBot');
        }
        if (corpSubscription?.limitValue?.synonymSearch !== corporationDetail.limitValue?.synonymSearch) {
            reasons.push('synonymSearch');
        }
        if (corpSubscription?.limitValue?.batchCommandService !== corporationDetail.limitValue?.batchCommandService) {
            reasons.push('batchCommandService');
        }
        if (corpSubscription?.limitValue?.convertPDF !== corporationDetail.limitValue?.convertPDF) {
            reasons.push('convertPDF');
        }
        if (corpSubscription?.limitValue?.chatAI !== corporationDetail.limitValue?.chatAI) {
            reasons.push('chatAI');
        }
        if (corpSubscription?.limitValue?.logAnalysis !== corporationDetail.limitValue?.logAnalysis) {
            reasons.push('logAnalysis');
        }
        if (corpSubscription?.limitValue?.ipRestriction !== corporationDetail.limitValue?.ipRestriction) {
            reasons.push('ipRestriction');
        }
        if (corpSubscription?.limitValue?.lincenseKeyPermission !== corporationDetail.limitValue?.lincenseKeyPermission) {
            reasons.push('lincenseKeyPermission');
        }
        if (corpSubscription?.limitValue?.aiAuto !== corporationDetail?.limitValue?.aiAuto) {
            reasons.push('aiAuto');
        }
        if (corpSubscription?.limitValue?.telephoneAgent !== corporationDetail?.limitValue?.telephoneAgent) {
            reasons.push(Constant.SETTING_VERSION_LABEL.TELEPHONE_AGENT);
        }
        if (corpSubscription?.limitValue?.sdAuto !== corporationDetail?.limitValue?.sdAuto) {
            reasons.push('sdAuto');
        }
        if (corpSubscription?.limitValue?.mcpServer !== corporationDetail?.limitValue?.mcpServer) {
            reasons.push('mcpServer');
        }
        if (corpSubscription?.limitValue?.externalWebAPI !== corporationDetail?.limitValue?.externalWebAPI) {
            reasons.push('externalWebAPI');
        }
        if (corpSubscription?.limitValue?.multiAuth !== corporationDetail?.limitValue?.multiAuth) {
            reasons.push('multiAuth');
        }

        if (reasons.length > 0) {
            return true;
        }
    }
    return false;
};


/**
 * onSubscriptionEventDeleteUserInProject
 * subscription listion remove user in project
 * @param {*} allState 
 * @param {*} id 
 * @returns 
 */
export const onSubscriptionEventDeleteUserInProject = (allState, id) => {

    if (!id) return;
    let subscriptions = APIAmplify.graphql({
        query: onUserProjectDeletedByUserId,
        variables: { id2: id }
    }).subscribe({
        next: resData => {
            let userData = resData?.value?.data?.onUserProjectDeletedByUserId;
            let projectDeletedUser = userData.projectId;
            if (!projectDeletedUser) return;

            // Using prj deleted
            if (projectDeletedUser === allState?.userDetail?.projectInuse) {
                let projectBaseData = allState.projectList.find(
                    project => project.type === Constant.PROJECT_TYPE.BASE
                );
                if (!projectBaseData || Utils.isEmptyObject(projectBaseData)) return;
                localStorageUtil.setSelectedProjectType(projectBaseData.type);
                localStorageUtil.setSelectedProjectId(projectBaseData.id);
                allState.setIsOpenModalReloadPageMain(true);
            } else {
                // Not using prj deleted => Remove prj deleted from projectList
                let currentProjectListRecoilState = cloneDeep(allState.projectList);
                if (!Utils.isEmptyArray(currentProjectListRecoilState)) {
                    let newProjectList = currentProjectListRecoilState.filter(
                        project => project.id !== projectDeletedUser
                    );
                    allState.setProjectListRecoil(newProjectList);
                }
            }
        },
        error: err => {
            console.log('onSubscriptionEventDeleteUserInProject err', err)
        }
    });

    return subscriptions
};

export const onSubscriptionEventUpdateCorporation = (allState, corporationDetail) => {
    if(!corporationDetail.id) return;
   let subscription =  APIAmplify.graphql({
        query: onCorporationUpdated,
        variables: {id: corporationDetail.id}
    }).subscribe({
        next: resData => {
            let corporationData = resData?.value?.data.onCorporationUpdated;
            // get logo url
            if (!Utils.isEmptyString(corporationData.image)) {
                let corporationLogo = Utils.getCloudFrontUrlForCorporationLogo({
                    type: Constant.S3_FILE_TYPE.CORPORATION_LOGO_PROFILE_FILE,
                    image: corporationData.image,
                    corporationId: corporationData.organizationDomain,
                    corporationDetail: corporationData
                });
                corporationData.corporationLogo = corporationLogo;
            } else {
                corporationData.corporationLogo = Constant.LOGO_DEFAULT;
            }
            // Preserve listChatGptModel injected from getCorporationDetail/getCorporationList (not in subscription)
            const prevCorporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
            const nextCorporationSetting = Utils.convertJSONDataToObject(corporationData?.corporationSetting);
            if (prevCorporationSetting?.listChatGptModel && !nextCorporationSetting?.listChatGptModel) {
                corporationData.corporationSetting = JSON.stringify({
                    ...nextCorporationSetting,
                    listChatGptModel: prevCorporationSetting.listChatGptModel
                });
            }

            allState.setCorpSubscription(corporationData);
            if (corporationData.rootFlag !== corporationDetail.rootFlag) {
                return
            }
            allState.setCorporationDetail(prev => ({
                ...prev,
                ...corporationData
            }));
        },
        error: err => {
            console.log('onSubscriptionEventUpdateCorporation err', err)
        }
    });

    return subscription
}

export const onSubscriptionEventUpdateTask = (taskId, setTaskIdAtom, setOpenBulkActionResultPopup, enqueueSnackbar, setIsShowDialogNotiLimit) => {
    if (!taskId || Utils.getPrefixOfId(taskId) !== 'task') return;
    let subscription =  APIAmplify.graphql({
        query: onTaskParentUpdated,
        variables: {id: taskId}
    }).subscribe({
        next: async resData => {
            let taskData = resData?.value?.data.onTaskParentUpdated;
            const taskIfo = Utils.convertJSONDataToObject(taskData?.info);
            let bulkActionType = taskIfo.bulkActionType
            if (taskData.id !== taskId) return;
            if (taskData.status !== Constant.TASK_STATUS.DONE) return; 
            setTaskIdAtom('');

            switch (bulkActionType) {
                case Constant.BULK_ACTION.EXPORT_CSV:
                case Constant.BULK_ACTION.HELPDESK_EXPORT_CSV:{
                    
                    const exportCsvS3CsvKey = taskIfo?.s3CsvKey;
                    const LIMIT_SIZE_FILE = 100000;
                    let linkFileDownload = '';

                    //show error
                    if (Utils.isEmptyString(exportCsvS3CsvKey))
                        return enqueueSnackbar(I18n.get('MSG-CM-API-ERROR-WHEN-EXPORT-CSV'), {
                            variant: 'error',
                            autoHideDuration: 3000
                        });

                    if (Utils.isEmptyString(taskIfo?.bulkHandleTicketTotal > LIMIT_SIZE_FILE))
                        return enqueueSnackbar(
                            I18n.get('MSG-CM-OVER-SIZE-FILE-ERROR-WHEN-EXPORT-CSV'),
                            {
                                variant: 'error',
                                autoHideDuration: 3000
                            }
                        );

                    linkFileDownload = exportCsvS3CsvKey.replaceAll('public/', ''); //remove public/ in s3 key
                    const csvFileName = taskIfo?.csvFileName;

                    const exportCsvUrl = await Storage.get(linkFileDownload, { level: 'public' });
                    const exportCsvRes = await fetch(exportCsvUrl);
                    const exportCsvBlob = await exportCsvRes.blob();

                    const exportCsvDownloadUrl = window.URL.createObjectURL(
                        new Blob([exportCsvBlob])
                    );
                    const downloadLink = document.createElement('a');

                    downloadLink.href = exportCsvDownloadUrl;
                    downloadLink.setAttribute('download', csvFileName);
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                    break;
                }
                case Constant.BULK_ACTION.EDIT_TAG_FIELD:
                case Constant.BULK_ACTION.EDIT_PUBLIC_RANGE:
                case Constant.BULK_ACTION.BACK_TO_DRAFT:
                case Constant.BULK_ACTION.SENT_TO_PUBLIC:
                case Constant.BULK_ACTION.RESTORE:
                case Constant.BULK_ACTION.SOFT_DELETE:
                case Constant.BULK_ACTION.HARD_DELETE:
                case Constant.BULK_ACTION.DUPLICATE:
                case Constant.BULK_ACTION.KNOWLEDGE_BOOKMARK_TICKET:{
                    if (taskIfo?.isSearchLimit) {
                        setIsShowDialogNotiLimit(true);
                        return;
                    }
                    //funcs need show popup
                    setOpenBulkActionResultPopup({
                        isOpen: true,
                        bulkActionResult: {
                            successCount: taskIfo?.resultSuccess || 0,
                            failCount: taskIfo?.resultFail || 0
                        },
                        panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
                    });

                    break;
                }
                case Constant.BULK_ACTION.HELPDESK_DELETE:
                case Constant.BULK_ACTION.HELPDESK_RESTORE:
                case Constant.BULK_ACTION.HELPDESK_SOFT_DELETE:
                case Constant.BULK_ACTION.HELPDESK_HARD_DELETE:
                case Constant.BULK_ACTION.HELPDESK_ARCHIVE:
                case Constant.BULK_ACTION.HELPDESK_BACK_TO_NEW_SUPPORT:
                case Constant.BULK_ACTION.HELPDESK_EDIT_TAG_FIELD:
                case Constant.BULK_ACTION.HELPDESK_BOOKMARK_TICKET:
                    if (taskIfo?.isSearchLimit) {
                        setIsShowDialogNotiLimit(true);
                        return;
                    }
                    //funcs need show popup
                    setOpenBulkActionResultPopup({
                        isOpen: true,
                        bulkActionResult: {
                            successCount: taskIfo?.resultSuccess || 0,
                            failCount: taskIfo?.resultFail || 0
                        },
                        panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST
                    });
                    break;
                case Constant.BULK_ACTION.DOWNLOAD_UPLOAD_TAG_ITEMS: {
                    //funcs need show popup
                    setOpenBulkActionResultPopup({
                        isOpen: true,
                        bulkActionResult: {
                            successCount: taskIfo?.resultSuccess || 0,
                            failCount: taskIfo?.resultFail || 0,
                            uploadKey: taskIfo?.uploadKey || '',
                            fieldId: taskIfo?.fieldId || '',
                        },
                        panelType: Constant.PANEL_TYPE.FORMAT_MANAGEMENT,
                    });
                    break
                }
                default:
                    break;
            }
            
        },
        error: err => {
            console.log('onSubscriptionEventUpdateTask err', err)
        }
    });

    return subscription
}

export const onChangeAdminModeHandler = async (API, newAdminMode, args) => {
    let userDetail = cloneDeep(args.userDetail);
    let userSetting = userDetail?.userSetting;
    if (!Utils.isEmptyObject(userSetting)) {
        userSetting = Utils.convertJSONDataToObject(userSetting);
    } else {
        userSetting = {};
    }

    args.setAdminMode(newAdminMode);

    // update user
    userSetting.adminMode = newAdminMode;
    let userDetailForUpdate = {
        id: userDetail.id,
        userSetting: JSON.stringify(userSetting)
    };
    updateUserById(API, userDetailForUpdate).then(updateResult => {

        // update state userDetail
        updateResult.avatar = userDetail.avatar;
        args.setUserDetail(updateResult);

        args.setPanelList(prev => {
            let clonedPanel = cloneDeep(prev);
            if (newAdminMode === Constant.ADMIN_MODE.OFF) {
                clonedPanel = clonedPanel.filter(panel => ![
                    Constant.PANEL_TYPE.ROOT_LIST_ORG,
                    Constant.PANEL_TYPE.PRODUCT_MANAGEMENT,
                    Constant.PANEL_TYPE.SYSTEM_MANAGEMENT
                ].includes(panel.type))
            }
            return clonedPanel;
        });

    }).catch(err => {
        console.log('onChangeAdminModeHandler updateUser err', err);
    });
};

export const setResourceLimitCorporationError = (argsAll, corporationDetail, userDetail) => {
    const limitValue = corporationDetail.limitValue;
    const isAdmin = isAdminUser(userDetail);

    if(!isAdmin || [Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType)) {
        return argsAll.setIsBeyondLimitTicket(false);
    }

    if (
        limitValue?.numOfTicket > limitValue?.maxNumOfTicket ||
        limitValue?.numOfStorage > limitValue?.maxNumOfStorage ||
        limitValue?.numOfB2CCustomer > limitValue?.maxNumOfB2CCustomer ||
        limitValue?.numOfTicketKnowledge > limitValue?.maxNumOfTicketKnowledge ||
        limitValue?.numOfInternalUser > limitValue?.maxNumOfInternalUser ||
        limitValue?.numOfGeneralProject > limitValue?.maxNumOfGeneralProject
    ) {
        argsAll.setIsBeyondLimitTicket(true);
    } else {
        argsAll.setIsBeyondLimitTicket(false);
    }
}


export const onSubscriptionEventUpdateProjectInuse = (allState, projectId) => {
    if(!projectId) return;

   let subscription =  APIAmplify.graphql({
        query: onProjectUpdated,
        variables: {id: projectId}
    }).subscribe({
        next: resData => {
            let projectData = resData?.value?.data?.onProjectUpdated;
            if (!projectData || Utils.isEmptyObject(projectData)) return;

            let isTriggerReload = triggerReloadUpdateProjectInuseByCondition(allState?.projectDetail, projectData);
            if (isTriggerReload && allState?.setIsShowDialogReload) {
                allState?.setIsShowDialogReload(true);
            }
        },
        error: err => {
            console.log('onSubscriptionEventUpdateCorporation err', err)
        }
    });

    return subscription
}

const triggerReloadUpdateProjectInuseByCondition = (oldProjectData, projectInuseData) => {
    if (projectInuseData.active === Constant.ACTIVE_FLAG.DELETED) {
        return true;
    }

    if (projectInuseData.managementPanel) {
        if (!oldProjectData?.managementPanel) {
            return true;
        }
        let newManagementPanel = Utils.convertJSONDataToObject(projectInuseData.managementPanel);
        let oldManagementPanel = Utils.convertJSONDataToObject(oldProjectData.managementPanel);
        let newManagementPanelActivePanel = newManagementPanel?.activePanel;
        let oldManagementPanelActivePanel = oldManagementPanel?.activePanel;
        
        if (!isEqual(newManagementPanelActivePanel, oldManagementPanelActivePanel)) {
            return true;
        }
    }

    return false;
}
